var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "button",
    {
      staticClass: "boss-button boss-button-confirm pega-button",
      class: _vm.buttonClass,
      attrs: { disabled: _vm.isDisabled },
      on: {
        click: function ($event) {
          return _vm.$emit("submit-event")
        },
      },
    },
    [
      _c("span", { staticClass: "boss-button-confirm-text" }, [
        _vm._v("\n    " + _vm._s(_vm.submitLabel) + "\n  "),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }